/* Portable browser-storage wishlist - drop-in, theme-agnostic.
   To reuse on another store: copy assets/wishlist.js + assets/wishlist.css +
   snippets/wishlist-button.liquid, load both assets in the layout, render the
   button snippet inside product cards / the product page, and put a
   [data-wishlist-grid] element on a wishlist page. No app, no backend. */
(function () {
  var KEY = (window.WISHLIST_KEY || 'shop_wishlist_v1');

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list: list } }));
  }
  function has(handle) { return read().some(function (i) { return i.handle === handle; }); }
  function count() { return read().length; }

  function toggle(item) {
    if (!item || !item.handle) return false;
    var list = read();
    var idx = list.findIndex(function (x) { return x.handle === item.handle; });
    if (idx >= 0) { list.splice(idx, 1); } else { list.unshift(item); }
    write(list);
    return idx < 0; // true => added
  }

  function itemFromButton(btn) {
    return {
      handle: btn.getAttribute('data-handle'),
      id: btn.getAttribute('data-id'),
      title: btn.getAttribute('data-title'),
      image: btn.getAttribute('data-image'),
      price: btn.getAttribute('data-price'),
      url: btn.getAttribute('data-url')
    };
  }

  function syncButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = has(btn.getAttribute('data-handle'));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function syncCount() {
    var n = count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      if (n === 0) { el.setAttribute('hidden', ''); } else { el.removeAttribute('hidden'); }
    });
  }

  function renderGrid() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var skeleton = document.querySelector('[data-wishlist-skeleton]');
    if (skeleton) skeleton.setAttribute('hidden', '');
    var list = read();
    var empty = document.querySelector('[data-wishlist-empty]');
    if (empty) { if (list.length) { empty.setAttribute('hidden', ''); } else { empty.removeAttribute('hidden'); } }
    grid.innerHTML = list.map(function (i) {
      var img = i.image ? '<img src="' + i.image + '" alt="" loading="lazy">' : '';
      return '<div class="wishlist-card">'
        + '<a class="wishlist-card__media" href="' + (i.url || '#') + '">' + img + '</a>'
        + '<button class="wishlist-card__remove" type="button" data-wishlist-toggle'
        + ' data-handle="' + (i.handle || '') + '" aria-label="Remove from wishlist">&times;</button>'
        + '<a class="wishlist-card__info" href="' + (i.url || '#') + '">'
        + '<span class="wishlist-card__title">' + (i.title || '') + '</span>'
        + '<span class="wishlist-card__price">' + (i.price || '') + '</span>'
        + '</a></div>';
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggle(itemFromButton(btn));
  });

  document.addEventListener('wishlist:change', function () { syncButtons(); syncCount(); renderGrid(); });

  function init() { syncButtons(); syncCount(); renderGrid(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

  window.Wishlist = { read: read, toggle: toggle, has: has, count: count };
})();
